/**
 * Initializes event listeners for telephone, email, WhatsApp, and swiper events.
 */
'use strict';

class ServerSideAnalytics {
  /**
   * Initializes event listeners.
   */
  constructor() {
    // Select telephone links
    this.telButtons = document.querySelectorAll('a[href^="tel:"]');
    // Add class js-emparse to mailto links, see src/js/modules/scramble-email.js
    this.mailButtons = document.querySelectorAll('a[href^="mailto:"], .js-emparse');
    // Add class whatsapp-cta to WhatsApp links
    this.waButtons = document.querySelectorAll('a[href^="https://wa.me/"], .whatsapp-cta');
    // Select swiper element
    this.swiper = document.querySelector('.swiper');

    // Add event listeners
    this.telButtonEvent = this.telButtonEvent.bind(this);
    this.telButtons.forEach((button) => {
      button.addEventListener('click',this.telButtonEvent);
    });

    this.mailButtonEvent = this.mailButtonEvent.bind(this);
    this.mailButtons.forEach((button) => {
      button.addEventListener('click', this.mailButtonEvent);
    });

    this.waButtonEvent = this.waButtonEvent.bind(this);
    this.waButtons.forEach((button) => {
      button.addEventListener('click', this.waButtonEvent);
    });

    this.swiper?.addEventListener('imageChange', this.swiperEvent.bind(this));
  }

  /**
   * Event handler for swiper event.
   * @param {Event} event - The swiper event.
   */
  swiperEvent(event) {
    if (event.detail.views === 10) {
      const data = {
        event_name: 'scrolled_ten_pictures',
      };
      this.sendToAPI(data);
    }
  }

  /**
   * Event handler for telephone button click event.
   * @param {Event} event - The click event.
   */
  telButtonEvent(event) {
    const target = event.target.closest('a');
    const data = {
      event_name: 'phone_call_click',
      link_href: target.href,
      link_href_formated: target.href.replace('tel:', ''),
      link_text: target.innerText,
      link_location: target.dataset.vehicleGtmClickEvent,
    };
    this.sendToAPI(data);
  }

  /**
   * Event handler for email button click event.
   * @param {Event} event - The click event.
   */
  mailButtonEvent(event) {
    const data = {
      event_name: 'email_click',
      link_href: event.target.href,
      link_href_formated: event.target.href.replace('mailto:', ''),
      link_text: event.target.innerText,
      link_location: event.target.dataset.vehicleGtmClickEvent,
    };
    this.sendToAPI(data);
  }

  /**
   * Event handler for WhatsApp button click event.
   * @param {Event} event - The click event.
   */
  waButtonEvent(event) {
    const target = event.target.closest('a');
    let vehicle = '';
    let link_location = '';

    // if car-card we can find the vehicle registration number in the data-reg-number attribute
    if (target.classList.contains('btn--whatsapp')) {
      vehicle = target.dataset.regNumber;
      link_location = 'car_card wa_button';
    }
    const data = {
      vehicle,
      event_name: 'whatsapp_click',
      link_href: target.href,
      link_text: target.innerText,
      link_location: target.dataset.vehicleGtmClickEvent || link_location,
    };
    this.sendToAPI(data);
  }

  /**
   * Sends data to API.
   *
   * @typedef {Object} AnalytiacsDataPayload
   * @property {string} event_name
   * @property {string} [link_href]
   * @property {string} [link_href_formated]
   * @property {string} [link_text]
   * @property {string} [link_location]
   * @property {string} [vehicle]
   *
   *
   * @param {AnalytiacsDataPayload} data - send data to API.
   */
  sendToAPI(data) {
    let vehicle = data.vehicle || '';
    if (!vehicle) {
      const datalayer = window.dataLayer || [];
      datalayer.forEach((item) => {
        if (item.pageInfo) {
          vehicle = item.pageInfo.registerNumberRaw;
        }
      });
    }

    const utmParams = this.parseUTM(window.location.href) || {};
    const serverData = {
      content_id: vehicle,
      relativeurl: window.location.pathname,
      title: document.title,
      ...utmParams,
      ...data,
    };
    fetch('/stage-ajax/ajax-send-serverside-analytics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(serverData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  /**
   * Parses UTM parameters from URL.
   * @param {string} url - The URL containing UTM parameters.
   * @returns {Object} - An object containing UTM parameters.
   */
  parseUTM(url) {
    try {
      const params = new URL(url).searchParams;
      return Object.fromEntries(params.entries());
    } catch (error) {
      return {}; // Return an empty object if there's an error
    }
  }
}

export default ServerSideAnalytics;
